import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card";
import Button from "../components/Button";
import Input from "../components/Input";
import API from "../api/api";

export default function LoginRegister() {
  const navigate = useNavigate();

  const [emailLogin, setEmailLogin] = useState("");
  const [passLogin, setPassLogin] = useState("");
  const [errorLogin, setErrorLogin] = useState("");

  const handleLogin = async () => {
    if (!emailLogin || !passLogin) {
      setErrorLogin("Complete todos los campos.");
      return;
    }

    setErrorLogin("");

    try {
      const res = await API.post("/auth/login/", {
        email: emailLogin,
        password: passLogin,
      });

      localStorage.setItem("access", res.data.access);
      localStorage.setItem("refresh", res.data.refresh);

      let userObj = {
        id: res.data.id,
        email: res.data.email,
        nombre: res.data.nombre,
        role: res.data.role,
      };

      if (!userObj.id || !userObj.email) {
        try {
          const perfilRes = await API.get("/perfil/");
          userObj = {
            id: perfilRes.data.id,
            email: perfilRes.data.email,
            nombre: perfilRes.data.nombre || perfilRes.data.email,
            role: perfilRes.data.role,
          };
        } catch (perfilErr) {
          console.error("Error obteniendo perfil:", perfilErr);
        }
      }

      localStorage.setItem("usuario", JSON.stringify(userObj));

      // Redirigir según rol
      if (userObj.role === "admin") {
        navigate("/admin", { replace: true });
      } else if (userObj.role === "cliente") {
        navigate("/dashboard-cliente", { replace: true });
      } else {
        navigate("/dashboard-comprador", { replace: true });
      }
    } catch (err) {
      console.error(err);
      setErrorLogin("Credenciales incorrectas.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-6 items-stretch">
        <section className="relative overflow-hidden rounded-[2rem] bg-ink text-cream p-8 md:p-10 shadow-2xl shadow-black/25">
          <div className="absolute inset-0 opacity-40">
            <div className="absolute -top-24 -left-20 h-72 w-72 rounded-full bg-moss blur-3xl" />
            <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-gold blur-3xl" />
          </div>

          <div className="relative z-10 h-full flex flex-col justify-between gap-10">
            <div className="inline-flex items-center justify-center rounded-2xl bg-cream p-5 shadow-xl shadow-black/20 w-fit">
              <img
                src="/Logod.png"
                alt="Global Soluciones Inteligentes"
                className="h-16 md:h-20 object-contain"
              />
            </div>

            <div className="space-y-5 max-w-xl">
              <span className="inline-block rounded-full border border-cream/20 bg-cream/10 px-4 py-2 text-sm text-cream/80">
                Plataforma de factoring B2B
              </span>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight">
                Gestión inteligente de facturas, ofertas y cesiones.
              </h1>
              <p className="text-cream/70 text-lg">
                Backoffice, compradores y vendedores conectados en un flujo seguro
                para validar, negociar y cerrar operaciones de factoring.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-3 text-center">
              <div className="rounded-2xl bg-cream/10 border border-cream/10 p-4">
                <p className="text-2xl font-bold text-gold">SET</p>
                <p className="text-xs text-cream/60">Validación</p>
              </div>
              <div className="rounded-2xl bg-cream/10 border border-cream/10 p-4">
                <p className="text-2xl font-bold text-moss">30%</p>
                <p className="text-xs text-cream/60">Control tasa</p>
              </div>
              <div className="rounded-2xl bg-cream/10 border border-cream/10 p-4">
                <p className="text-2xl font-bold text-cream">3P</p>
                <p className="text-xs text-cream/60">Contrato</p>
              </div>
            </div>
          </div>
        </section>

        <Card className="bg-cream/90 p-8 md:p-10 flex flex-col justify-center">
          <div className="mb-8">
            <p className="text-sm uppercase tracking-[0.25em] text-moss font-semibold">
              Acceso seguro
            </p>
            <h2 className="text-3xl font-bold text-primary mt-2">
              Iniciar sesión
            </h2>
            <p className="text-stone-500 mt-2">
              Ingresá con tu usuario para continuar al panel correspondiente.
            </p>
          </div>

          <div className="space-y-4">
            <Input
              label="Email"
              type="email"
              value={emailLogin}
              onChange={(e) => setEmailLogin(e.target.value)}
            />

            <Input
              label="Contraseña"
              type="password"
              value={passLogin}
              onChange={(e) => setPassLogin(e.target.value)}
            />

            {errorLogin && (
              <p className="rounded-lg border border-red-200 bg-red-50 p-3 text-red-700 text-sm">
                {errorLogin}
              </p>
            )}

            <Button onClick={handleLogin} className="w-full py-3 text-base">
              Entrar
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
